import { popoverClasses } from "@mui/material";
const MuiPopover = {
    defaultProps: {
        componentsProps: {
            backdrop: {
                'aria-hidden': false
            }
        }
    },
    styleOverrides: {
        root: ({ theme })=>({
                borderRadius: theme.shape.borderRadius,
                [`& .${popoverClasses.paper}`]: {
                    backgroundColor: theme.palette.background.popover,
                    ...'dark' === theme.palette.mode && {
                        backgroundImage: 'unset'
                    }
                }
            })
    }
};
export { MuiPopover };

//# sourceMappingURL=popover-overrides.js.map